import React, { FC } from "react";
import { Box, CircularProgress, Modal } from "@material-ui/core";
import { useHookstate } from "@hookstate/core";
import networkState from "states/networkState";

export interface LoaderProviderProps {}

const LoaderProvider: FC<LoaderProviderProps> = ({ children }) => {
  const network = useHookstate(networkState);

  return (
    <>
      {children}
      <Modal
        open={network.requesting.value > 0}
        disableEnforceFocus
        disableAutoFocus
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      </Modal>
    </>
  );
};

export default LoaderProvider;
